export default [
  {
    header: 'ClientPortal.SideMenu.Adsmanager',
  },
  {
    title: 'ClientPortal.SideMenu.Statistics',
    route: 'statistics',
    icon: 'Analytics',
  },
  {
    title: 'ClientPortal.SideMenu.Create',
    icon: 'Plus',
    children: [
      {
        title: 'ClientPortal.SideMenu.Campaign',
        route: 'campaign',
      },
      {
        title: 'ClientPortal.SideMenu.AdGroup',
        route: 'ad-group',
      },
      {
        title: 'ClientPortal.SideMenu.Ad',
        route: 'ad',
      },
    ],
  },
  {
    title: 'ClientPortal.SideMenu.Surveys',
    route: 'surveys',
    icon: 'Question',
  },
  {
    title: 'ClientPortal.SideMenu.Gallery',
    route: 'gallery',
    icon: 'Image',
  },
]
